// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * TaskBoardAttributes type.
 * @typedef {object} TaskBoardAttributes
 * @property {string} boardColumnId - Attribute value.
 * @property {string} boardId - Attribute value.
 * @property {Date} createdAt - Attribute value.
 * @property {string} id - Attribute value.
 * @property {number} rowNumber - Attribute value.
 * @property {string} taskId - Attribute value.
 * @property {Date} updatedAt - Attribute value.
 */
/**
 * Attributes accepted by TaskBoardCreateAttributes.
 * @typedef {object} TaskBoardCreateAttributes
 * @property {TaskBoardAttributes["boardColumnId"] | null} [boardColumnId] - Permitted boardColumnId value.
 * @property {TaskBoardAttributes["rowNumber"] | null} [rowNumber] - Permitted rowNumber value.
 * @property {TaskBoardAttributes["taskId"] | null} [taskId] - Permitted taskId value.
 */
/**
 * Attributes accepted by TaskBoardUpdateAttributes.
 * @typedef {object} TaskBoardUpdateAttributes
 * @property {TaskBoardAttributes["boardColumnId"] | null} [boardColumnId] - Permitted boardColumnId value.
 * @property {TaskBoardAttributes["rowNumber"] | null} [rowNumber] - Permitted rowNumber value.
 * @property {TaskBoardAttributes["taskId"] | null} [taskId] - Permitted taskId value.
 */
/**
 * Frontend model for TaskBoard.
 * @augments {FrontendModelBase<TaskBoardAttributes, TaskBoardCreateAttributes, TaskBoardUpdateAttributes, TaskBoardAttributes["id"], string>}
 */
class TaskBoard extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "TaskBoard",
      attributes: [
        "boardColumnId",
        "boardId",
        "createdAt",
        "id",
        "rowNumber",
        "taskId",
        "updatedAt",
      ],
      collectionCommands: [
        "availableBoardsForTask",
        "place",
        "placeOnBoard",
        "removeFromBoard",
        "reorder",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      board: {type: "belongsTo"},
      boardColumn: {type: "belongsTo"},
      task: {type: "belongsTo"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      board: "Board",
      boardColumn: "BoardColumn",
      task: "Task",
    }
  }

  /** @returns {TaskBoardAttributes["boardColumnId"]} - Attribute value. */
  boardColumnId() { return /** @type {TaskBoardAttributes["boardColumnId"]} */ (this.readAttribute("boardColumnId")) }

  /**
   * @param {TaskBoardAttributes["boardColumnId"] | null} newValue - New attribute value.
   * @returns {TaskBoardAttributes["boardColumnId"] | null} - Assigned value.
   */
  setBoardColumnId(newValue) { return /** @type {TaskBoardAttributes["boardColumnId"] | null} */ (this.setAttribute("boardColumnId", newValue)) }

  /** @returns {TaskBoardAttributes["boardId"]} - Attribute value. */
  boardId() { return /** @type {TaskBoardAttributes["boardId"]} */ (this.readAttribute("boardId")) }

  /**
   * @param {TaskBoardAttributes["boardId"] | null} newValue - New attribute value.
   * @returns {TaskBoardAttributes["boardId"] | null} - Assigned value.
   */
  setBoardId(newValue) { return /** @type {TaskBoardAttributes["boardId"] | null} */ (this.setAttribute("boardId", newValue)) }

  /** @returns {TaskBoardAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {TaskBoardAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string} newValue - New attribute value.
   * @returns {Date | string} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {TaskBoardAttributes["id"]} - Attribute value. */
  id() { return /** @type {TaskBoardAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {TaskBoardAttributes["id"] | null} newValue - New attribute value.
   * @returns {TaskBoardAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {TaskBoardAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {TaskBoardAttributes["rowNumber"]} - Attribute value. */
  rowNumber() { return /** @type {TaskBoardAttributes["rowNumber"]} */ (this.readAttribute("rowNumber")) }

  /**
   * @param {TaskBoardAttributes["rowNumber"] | null} newValue - New attribute value.
   * @returns {TaskBoardAttributes["rowNumber"] | null} - Assigned value.
   */
  setRowNumber(newValue) { return /** @type {TaskBoardAttributes["rowNumber"] | null} */ (this.setAttribute("rowNumber", newValue)) }

  /** @returns {TaskBoardAttributes["taskId"]} - Attribute value. */
  taskId() { return /** @type {TaskBoardAttributes["taskId"]} */ (this.readAttribute("taskId")) }

  /**
   * @param {TaskBoardAttributes["taskId"] | null} newValue - New attribute value.
   * @returns {TaskBoardAttributes["taskId"] | null} - Assigned value.
   */
  setTaskId(newValue) { return /** @type {TaskBoardAttributes["taskId"] | null} */ (this.setAttribute("taskId", newValue)) }

  /** @returns {TaskBoardAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {TaskBoardAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string} newValue - New attribute value.
   * @returns {Date | string} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string} */ (this.setAttribute("updatedAt", newValue)) }

  /**
   * Runs availableBoardsForTask.
   * @param {import("../../../shared/task-board-placement-command-types.js").TaskBoardAvailableBoardsRequest} payload - Command argument.
   * @returns {Promise<import("../../../shared/task-board-placement-command-types.js").TaskBoardAvailableBoardsResponse>} - Command response.
   */
  static async availableBoardsForTask(payload) {
    return /** @type {import("../../../shared/task-board-placement-command-types.js").TaskBoardAvailableBoardsResponse} */ (await this.executeCustomCommand({
      commandName: "available-boards-for-task",
      commandType: "available-boards-for-task",
      payload: TaskBoard.normalizeCustomCommandPayloadArguments([payload]),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs place.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{taskBoard: import("./task-board.js").default}>} - Command response.
   */
  static async place(...commandArguments) {
    return /** @type {{taskBoard: import("./task-board.js").default}} */ (await this.executeCustomCommand({
      commandName: "place",
      commandType: "place",
      payload: TaskBoard.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs placeOnBoard.
   * @param {import("../../../shared/task-board-placement-command-types.js").TaskBoardPlacementRequest} payload - Command argument.
   * @returns {Promise<import("../../../shared/task-board-placement-command-types.js").TaskBoardPlaceOnBoardResponse>} - Command response.
   */
  static async placeOnBoard(payload) {
    return /** @type {import("../../../shared/task-board-placement-command-types.js").TaskBoardPlaceOnBoardResponse} */ (await this.executeCustomCommand({
      commandName: "place-on-board",
      commandType: "place-on-board",
      payload: TaskBoard.normalizeCustomCommandPayloadArguments([payload]),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs removeFromBoard.
   * @param {import("../../../shared/task-board-placement-command-types.js").TaskBoardPlacementRequest} payload - Command argument.
   * @returns {Promise<import("../../../shared/task-board-placement-command-types.js").TaskBoardRemoveFromBoardResponse>} - Command response.
   */
  static async removeFromBoard(payload) {
    return /** @type {import("../../../shared/task-board-placement-command-types.js").TaskBoardRemoveFromBoardResponse} */ (await this.executeCustomCommand({
      commandName: "remove-from-board",
      commandType: "remove-from-board",
      payload: TaskBoard.normalizeCustomCommandPayloadArguments([payload]),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs reorder.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{taskBoard: import("./task-board.js").default}>} - Command response.
   */
  static async reorder(...commandArguments) {
    return /** @type {{taskBoard: import("./task-board.js").default}} */ (await this.executeCustomCommand({
      commandName: "reorder",
      commandType: "reorder",
      payload: TaskBoard.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Returns board relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<TaskBoard, import("./board.js").Board, import("./board.js").BoardCreateAttributes>} - Relationship helper.
   */
  boardRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<TaskBoard, import("./board.js").Board, import("./board.js").BoardCreateAttributes>} */ (this.getRelationshipByName("board")) }

  /**
   * Returns board.
   * @returns {import("./board.js").Board | null} - Loaded related model.
   */
  board() { return this.boardRelationship().loaded() }

  /**
   * Builds board.
   * @param {import("./board.js").BoardCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./board.js").Board} - Built related model.
   */
  buildBoard(attributes = {}) { return this.boardRelationship().build(attributes) }

  /**
   * Loads board.
   * @returns {Promise<import("./board.js").Board | null>} - Loaded related model.
   */
  async loadBoard() { return await this.boardRelationship().load() }

  /**
   * Returns or loads board.
   * @returns {Promise<import("./board.js").Board | null>} - Loaded related model.
   */
  async boardOrLoad() { return await this.boardRelationship().orLoad() }

  /**
   * Sets board.
   * @param {import("./board.js").Board | null} model - Related model.
   * @returns {void}
   */
  setBoard(model) { this.boardRelationship().setLoaded(model) }

  /**
   * Returns boardColumn relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<TaskBoard, import("./board-column.js").BoardColumn, import("./board-column.js").BoardColumnCreateAttributes>} - Relationship helper.
   */
  boardColumnRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<TaskBoard, import("./board-column.js").BoardColumn, import("./board-column.js").BoardColumnCreateAttributes>} */ (this.getRelationshipByName("boardColumn")) }

  /**
   * Returns boardColumn.
   * @returns {import("./board-column.js").BoardColumn | null} - Loaded related model.
   */
  boardColumn() { return this.boardColumnRelationship().loaded() }

  /**
   * Builds boardColumn.
   * @param {import("./board-column.js").BoardColumnCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./board-column.js").BoardColumn} - Built related model.
   */
  buildBoardColumn(attributes = {}) { return this.boardColumnRelationship().build(attributes) }

  /**
   * Loads boardColumn.
   * @returns {Promise<import("./board-column.js").BoardColumn | null>} - Loaded related model.
   */
  async loadBoardColumn() { return await this.boardColumnRelationship().load() }

  /**
   * Returns or loads boardColumn.
   * @returns {Promise<import("./board-column.js").BoardColumn | null>} - Loaded related model.
   */
  async boardColumnOrLoad() { return await this.boardColumnRelationship().orLoad() }

  /**
   * Sets boardColumn.
   * @param {import("./board-column.js").BoardColumn | null} model - Related model.
   * @returns {void}
   */
  setBoardColumn(model) { this.boardColumnRelationship().setLoaded(model) }

  /**
   * Returns task relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<TaskBoard, import("./task.js").Task, import("./task.js").TaskCreateAttributes>} - Relationship helper.
   */
  taskRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<TaskBoard, import("./task.js").Task, import("./task.js").TaskCreateAttributes>} */ (this.getRelationshipByName("task")) }

  /**
   * Returns task.
   * @returns {import("./task.js").Task | null} - Loaded related model.
   */
  task() { return this.taskRelationship().loaded() }

  /**
   * Builds task.
   * @param {import("./task.js").TaskCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./task.js").Task} - Built related model.
   */
  buildTask(attributes = {}) { return this.taskRelationship().build(attributes) }

  /**
   * Loads task.
   * @returns {Promise<import("./task.js").Task | null>} - Loaded related model.
   */
  async loadTask() { return await this.taskRelationship().load() }

  /**
   * Returns or loads task.
   * @returns {Promise<import("./task.js").Task | null>} - Loaded related model.
   */
  async taskOrLoad() { return await this.taskRelationship().orLoad() }

  /**
   * Sets task.
   * @param {import("./task.js").Task | null} model - Related model.
   * @returns {void}
   */
  setTask(model) { this.taskRelationship().setLoaded(model) }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(TaskBoard)

export {TaskBoard}

export default TaskBoard
